import { createSlice } from "@reduxjs/toolkit";
import { aoiBasinMap } from "../config/config";
import { API_URL } from "../config/config.data";
import basins from "../config/entities/entity.basins";
import people from "../config/entities/entity.people";
import axios from "axios";

export const getLayerGroups = () => {
  const url = API_URL + `/${basins.endpoint}`;
  return axios.get(url)
}

export const parseLayerGroup = (basin) => {
  let tempLayerGroup = {};
  const basinPeopleUrl = API_URL + `/${basins.endpoint}/${basin.id}/${people.endpoint}`
  return axios.get(basinPeopleUrl).then(r=>{
    const people = r.data.people;
    const isNational = basin?.name === "NGWOS National Projects";
    tempLayerGroup = {
      icon: isNational ? "fas fa-map-marked-alt" : "fas fa-map-marker-alt",
      openByDefault: isNational ? true : false,
      pointLayers: ["non-ngwos-project-sites"],
      divider: isNational ? true : false,
      zoomToAoi: isNational ? false : true,
      // set aoiIds correctly for non national basins
      aoiIds: isNational ? undefined : aoiBasinMap[basin.name],
      layerGroupInfo: {
        name: `${basin.name} Information`,
        avatar: "avatarsrc.png",
        description:
          "Substantial advances in water science, together with emerging breakthroughs in technical and computational capabilities, have led the USGS to develop a Next Generation Water Observing System (NGWOS). The USGS NGWOS will provide real-time data on water quantity and quality in more affordable and rapid ways than previously possible, and in more locations.",
        people: people,
        quickLinks: [
          {
            title: isNational ? "Next Generation Water Observing System (NGWOS)" : basin.name,
            description: isNational ? "Program Home" : "Basin Home",
            src: basin.website_url
          },
          {
            title: "ScienceBase Home Page",
            description: "NGWOS Data and Projects",
            src: basin.sciencebase_url
          }
        ],
      },
    }

    return {
      name: basin.name,
      layerGroup: tempLayerGroup
    }
  })
}

export const layerGroupSlice = createSlice({
  name: "layerGroup",
  // initialState: layerGroupConfig,
  initialState: { allIds: [] },
  reducers: {
    addLayerGroup(state, action) {
      state[action.payload.name] = action.payload.layerGroup;
    },
    setlayerGroups(state, action) {
      state.basins = action.payload;
    },
    addBasinToAllIds(state, action) {
      if (!state.allIds.includes(action.payload)) {
        state.allIds = [...state.allIds, action.payload];
      }
    },
    openLayerControlGroup(state, action) {
      state[action.payload.id].show = true;
    },
    toggleLayerControlGroup(state, action) {
      state.allIds.forEach((id) => {
        if (action.payload.id === id) {
          state[id].show = !state[id].show;
        } else {
          state[id].show = false;
        }
      });
    },
  },
});
